import React from 'react';
import './news.css';

interface NewsProps {
    t: (key: string) => string;
}

const News: React.FC<NewsProps> = ({t}) => {

    return (
        <div className="news__main_wrapper">
            <div className="news__inner_wrapper">

                <div className="news__headline">
                    {t('tab_news_headline')}
                </div>

                <div dangerouslySetInnerHTML={{ __html: t('tab_news_paragraph') }} />

            </div>
        </div>
    )

}

export default News;
